import { render, staticRenderFns } from "./PartsLists.vue?vue&type=template&id=e615c084&scoped=true&"
import script from "./PartsLists.vue?vue&type=script&lang=js&"
export * from "./PartsLists.vue?vue&type=script&lang=js&"
import style0 from "./PartsLists.vue?vue&type=style&index=0&id=e615c084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e615c084",
  null
  
)

export default component.exports